import React from 'react';
import { COMPANY } from '@ApplicationWide/routes/route-groups';
import { OrgChartIcon } from '@Generic/icons';
const OrgChartPage = React.lazy(() => import('../../../pages/Company/OrgChart/OrgChartPage'));

export default {
  label: 'org-chart-page.title',
  group: COMPANY,
  to: '/company/org-chart',
  route: '/company/org-chart',
  area: 'orgChart', // Area is used to check if user has permission to view that Page or not, in case of no area given the page is always visible.
  orderInGroup: 30,
  component: OrgChartPage,
  icon: <OrgChartIcon />,
  isDesktopOnly: true,
  appearsInNavBar: true,
  hasNavBar: true,
};
